<script setup>
import { Handle, Position } from '@vue-flow/core'

const props = defineProps({
    id: String,
    data: Object,
})
</script>

<template>
    <div class="workflow-node workflow-node--delay">
        <Handle type="target" :position="Position.Top" />
        <div class="workflow-node__type">DELAY</div>
        <div class="workflow-node__title">
            Wait {{ data?.config?.amount || 1 }} {{ data?.config?.unit || 'hours' }}
        </div>
        <Handle type="source" :position="Position.Bottom" />
    </div>
</template>
